/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

export interface DownloadOptions {
  filename: string;
  mimeType?: string;
}

export function useFileDownload() {
  const downloadBlob = (blob: Blob, options: DownloadOptions) => {
    const url = URL.createObjectURL(blob);

    // Create a temporary link element
    const link = document.createElement("a");
    link.href = url;
    link.download = options.filename;
    link.style.display = "none";

    // Add to DOM, click, and clean up
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up the URL
    URL.revokeObjectURL(url);
  };

  const downloadText = (text: string, options: DownloadOptions) => {
    const blob = new Blob([text], {
      type: options.mimeType ?? "text/plain;charset=utf-8",
    });
    downloadBlob(blob, options);
  };

  const downloadJSON = (data: unknown, filename: string) => {
    const text = JSON.stringify(data, null, 2);
    downloadText(text, {
      filename: filename.endsWith(".json") ? filename : `${filename}.json`,
      mimeType: "application/json",
    });
  };

  const downloadCSV = (data: string, filename: string) => {
    downloadText(data, {
      filename: filename.endsWith(".csv") ? filename : `${filename}.csv`,
      mimeType: "text/csv;charset=utf-8",
    });
  };

  return {
    downloadBlob,
    downloadText,
    downloadJSON,
    downloadCSV,
  };
}
